const hierarchyTypeValues = {
    NONE: 0,
    MASTER: 1,
    SLAVE: 2
}

export {
    hierarchyTypeValues
}